import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TgGridModule, TgRackModule } from '@trademe/tangram';
import { ResidentialForSaleSummaryPageContactDetailsSectionComponent } from './summary-page-contact-details-section.component';

@NgModule({
    imports: [CommonModule, TgRackModule, TgGridModule, RouterModule],
    declarations: [
        ResidentialForSaleSummaryPageContactDetailsSectionComponent
    ],
    exports: [ResidentialForSaleSummaryPageContactDetailsSectionComponent]
})
export class ResidentialForSaleSummaryPageContactDetailsSectionModule {}
